const SubtitleLink = ({jump, value}) => {
    const {link_id, content} = value;
    const onClick = e => {
        e.stopPropagation();
        e.preventDefault();
        jump(link_id, content)
    }
    return <span className="subtitle-link clickable" onClick={onClick} dangerouslySetInnerHTML={{__html: content}} />
}
export default SubtitleLink;